class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.FoxTheme = window.FoxTheme || {};
    window.FoxTheme.Cart = this;
    this.drawer = this.closest("drawer-component");
    window.FoxTheme.CartDrawer = this.drawer;
    this.openWhenAdded = this.dataset.openWhenAdded === "true";
  }

  connectedCallback() {
    window.FoxThemeEvents.subscribe(
        PUB_SUB_EVENTS.cartUpdate,
        async (state) => {

          // Handle different types of state data
          if (state && state.sections && state.sections['cart-drawer']) {
            // Full state with sections - render normally
            this.renderContents(state);
          } else if (state) {
            // Just cart data - fetch sections and render
            await this.handleCartDataOnly(state);
          } else {
            console.warn("Cart Drawer: No state data received");
          }
        }
    );
  }

  // Handle when we only receive cart data without sections
  async handleCartDataOnly(cartData) {
    try {
      // Update basic cart info immediately
      this.updateBasicCartInfo(cartData);

      // Try to fetch and render sections
      await this.fetchAndRenderSections(cartData);

    } catch (error) {
      console.error('Error handling cart data:', error);
      // If section fetching fails, just show basic cart info
      this.updateBasicCartInfo(cartData);
    }
  }

  // Update basic cart information without sections
  updateBasicCartInfo(cartData) {
    // Update empty state
    this.classList.toggle("is-empty", cartData.item_count === 0);

    // Update cart count in drawer title
    const cartCountElement = this.querySelector('[data-cart-count-number][data-type="drawer"]');
    if (cartCountElement) {
      cartCountElement.textContent = cartData.item_count;
    }

    // Update cart count text
    const cartCountText = this.querySelector('[data-cart-count-text]');
    if (cartCountText && window.FoxThemeStrings && window.FoxThemeStrings.cartItemsCount) {
      cartCountText.textContent = window.FoxThemeStrings.cartItemsCount.replace('[count]', cartData.item_count);
    }
  }

  // Fetch sections and render
  async fetchAndRenderSections(cartData) {
    try {

      // Use a simpler approach - just reload the cart drawer content
      const response = await fetch(window.location.href);
      if (!response.ok) {
        throw new Error(`Page fetch failed: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Find the cart drawer items in the fresh HTML
      const freshCartDrawerItems = doc.querySelector('.f-cart-drawer__items');
      const freshCartDrawerFooter = doc.querySelector('.f-drawer__footer');

      // Update the current cart drawer with fresh content
      if (freshCartDrawerItems) {
        const currentCartDrawerItems = this.querySelector('.f-cart-drawer__items');
        if (currentCartDrawerItems) {
          currentCartDrawerItems.innerHTML = freshCartDrawerItems.innerHTML;
        }
      }

      if (freshCartDrawerFooter) {
        const currentCartDrawerFooter = this.querySelector('.f-drawer__footer');
        if (currentCartDrawerFooter) {
          currentCartDrawerFooter.innerHTML = freshCartDrawerFooter.innerHTML;
        }
      }


    } catch (error) {
      console.error('Error fetching cart drawer sections:', error);
      throw error;
    }
  }

  renderContents(parsedState, renderFooter = true) {

    // Validate that we have the required data
    if (!parsedState || !parsedState.sections) {
      console.error("Cart Drawer: Cannot render - missing parsedState.sections");
      return;
    }

    this.classList.contains("is-empty") && this.classList.remove("is-empty");
    this.classList.toggle("is-empty", parsedState.item_count === 0);

    this.getSectionsToRender(renderFooter).forEach((section) => {

      // Check if section data exists
      if (!parsedState.sections[section.id]) {
        console.warn(`Cart Drawer: Missing section data for ${section.id}`);
        return;
      }

      const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

      if (!sectionElement) {
        console.warn(`Cart Drawer: Could not find element for section ${section.id}`);
        return;
      }

      try {
        const innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
        );
        if (innerHTML) {
          sectionElement.innerHTML = innerHTML;
        }
      } catch (error) {
        console.error(`Cart Drawer: Error rendering section ${section.id}:`, error);
      }
    });

    setTimeout(() => {
      if (this.openWhenAdded && this.drawer && !this.drawer.isOpen()) {
        this.drawer.openDrawer();
        document.body.classList.add("prevent-scroll");
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState);
      }
    }, 50);
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    try {
      if (!html) {
        console.warn("Cart Drawer: No HTML provided for parsing");
        return "";
      }

      const parsed = new DOMParser().parseFromString(html, "text/html");
      const element = parsed.querySelector(selector);

      if (!element) {
        console.warn(`Cart Drawer: Could not find element with selector ${selector}`);
        return "";
      }

      return element.innerHTML;
    } catch (error) {
      console.error("Cart Drawer: Error parsing HTML:", error);
      return "";
    }
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
    ];

    if (renderFooter) {
      sections.push({
        id: "cart-drawer",
        selector: ".f-drawer__footer",
      });
    }

    return sections;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(
        document.querySelector("cart-drawer"),
        { overlay: document.querySelector("cart-drawer") }
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".f-cart-drawer__items",
      },
      {
        id: "cart-drawer",
        section: "cart-drawer",
        selector: ".f-cart-drawer__block-subtotal",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
